// ─── All certificatations ────────────────────────────────────────────────────────────────

import { FormState } from "../../components/pages/certificates/types";
import { generateCerts } from "../../helpers/certificate";
import { CertificationData } from "../../types/certificate";

export const CERT_RAW = [
  {
    title: "ISO 9001:2015 Quality Management",
    issuedBy: "Bureau Veritas",
    status: "active" as const,
    issued: "2023-06-15",
    expiry: "2026-06-14",
  },
  {
    title: "ISO 14001:2015 Environmental Management",
    issuedBy: "SGS Certification",
    status: "active" as const,
    issued: "2023-03-10",
    expiry: "2026-03-09",
  },
  {
    title: "ISO 45001:2018 Occupational Health & Safety",
    issuedBy: "TÜV SÜD",
    status: "active" as const,
    issued: "2022-11-20",
    expiry: "2025-11-19",
  },
  {
    title: "CE Marking — Surveying Instruments",
    issuedBy: "Dekra CE",
    status: "active" as const,
    issued: "2024-01-08",
    expiry: "2027-01-07",
  },
  {
    title: "ATEX Equipment Directive",
    issuedBy: "Intertek",
    status: "expired" as const,
    issued: "2020-05-01",
    expiry: "2023-04-30",
  },
  {
    title: "RoHS Compliance Certificate",
    issuedBy: "UL Verification",
    status: "active" as const,
    issued: "2023-09-12",
    expiry: "2026-09-11",
  },
  {
    title: "EN ISO 17123 Field Procedures",
    issuedBy: "UKAS Accreditation",
    status: "active" as const,
    issued: "2023-07-22",
    expiry: "2026-07-21",
  },
  {
    title: "FCC Part 15 Radio Frequency",
    issuedBy: "FCC Certification",
    status: "active" as const,
    issued: "2024-02-14",
    expiry: "2027-02-13",
  },
  {
    title: "IECEX Explosive Atmospheres",
    issuedBy: "DNV GL",
    status: "expired" as const,
    issued: "2019-08-30",
    expiry: "2022-08-29",
  },
  {
    title: "REACH Regulation Compliance",
    issuedBy: "Eurofins Scientific",
    status: "pending" as const,
    issued: "2024-11-01",
    expiry: "2027-10-31",
  },
  {
    title: "IPX7 Waterproofing Standard",
    issuedBy: "MET Laboratories",
    status: "active" as const,
    issued: "2023-04-18",
    expiry: "2026-04-17",
  },
  {
    title: "MIL-STD-810H Environmental Testing",
    issuedBy: "NTS Laboratories",
    status: "active" as const,
    issued: "2022-10-05",
    expiry: "2025-10-04",
  },
  {
    title: "Bluetooth SIG Qualification",
    issuedBy: "Bluetooth SIG",
    status: "active" as const,
    issued: "2024-03-27",
    expiry: "2027-03-26",
  },
  {
    title: "WEEE Directive Registration",
    issuedBy: "Compliance Europe",
    status: "pending" as const,
    issued: "2024-12-01",
    expiry: "",
  },
  {
    title: "IC Canada RSS-Gen Certification",
    issuedBy: "Innovation Canada",
    status: "active" as const,
    issued: "2023-08-09",
    expiry: "2026-08-08",
  },
  {
    title: "AS/NZS 4268 Radio Communications",
    issuedBy: "ACMA Australia",
    status: "expired" as const,
    issued: "2020-02-14",
    expiry: "2023-02-13",
  },
];

export const ALL_CERTS = generateCerts();

export const PAGE_SIZES = [9, 18, 36];

// ─── Manage Certifications ────────────────────────────────────────────────────────────────

export const MOCK_CERT: CertificationData = {
  title: "ISO 9001:2015 Quality Management",
  description:
    "Aurel Global has achieved ISO 9001:2015 certification, demonstrating our commitment to consistent quality management systems across all surveying instrument manufacturing processes.",
  imageUrl: "",
  issuedBy: "Bureau Veritas Certification",
  issuedDate: "2023-06-15",
  expiryDate: "2026-06-14",
  status: "active",
};

export const EMPTY_FORM = (): FormState => ({
  title: "",
  description: "",
  imageUrl: "",
  imageFile: null,
  imagePreview: "",
  issuedBy: "",
  issuedDate: "",
  expiryDate: "",
  status: "active",
});
